import { Component, ElementRef, HostBinding, HostListener, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss']
})
export class ContextMenuComponent implements OnDestroy{
  constructor(private elementRef: ElementRef, private sharedService: SharedService)  {}
  x: number;
  y: number;
  show$ = new BehaviorSubject<boolean>(false);
  mousedown: Subscription;

  ngOnDestroy(): void {
    this.mousedown?.unsubscribe();
  }

  open(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.x = event.layerX;
    this.y = event.layerY;
    this.show$.next(true);
    this.mousedown = this.sharedService.onEvent$('mousedown').subscribe((e: MouseEvent) => this.close(e));
  }
  close(event?: MouseEvent) {
    if (!event || !this.elementRef.nativeElement.contains(event.target)) {
      this.show$.next(false);
      this.mousedown?.unsubscribe();
    }
  }
}
